/**
 * LabelSkeleton - 标签加载骨架屏
 * 用于标签内容加载时的占位显示
 */

import React from 'react';
import './LabelSkeleton.css';

export default function LabelSkeleton({ templateType }) {
  const isStandardTemplate = templateType === 'standard-food-label' || templateType === 'blue-white-template';

  return (
    <div className="label-skeleton">
      {/* 标题骨架 */}
      {!isStandardTemplate && (
        <div className="skeleton-header">
          <div className="skeleton-title"></div>
        </div>
      )}

      {/* 内容骨架 */}
      <div className="skeleton-content">
        {/* 图片骨架 */}
        <div className="skeleton-item skeleton-image"></div>

        {/* 文本块骨架 */}
        <div className="skeleton-item skeleton-text-block">
          <div className="skeleton-text skeleton-text-title"></div>
          <div className="skeleton-text skeleton-text-line"></div>
          <div className="skeleton-text skeleton-text-line"></div>
          <div className="skeleton-text skeleton-text-line short"></div>
        </div>

        {/* 营养成分表骨架 */}
        <div className="skeleton-item skeleton-table">
          <div className="skeleton-text skeleton-text-title"></div>
          <div className="skeleton-table-rows">
            {[1, 2, 3, 4, 5].map(i => (
              <div key={i} className="skeleton-table-row">
                <div className="skeleton-text"></div>
                <div className="skeleton-text short"></div>
              </div>
            ))}
          </div>
        </div>

        {/* 更多文本块 */}
        <div className="skeleton-item skeleton-text-block">
          <div className="skeleton-text skeleton-text-title"></div>
          <div className="skeleton-text skeleton-text-line"></div>
          <div className="skeleton-text skeleton-text-line"></div>
        </div>

        {/* 按钮骨架 */}
        <div className="skeleton-item skeleton-buttons">
          <div className="skeleton-button"></div>
          <div className="skeleton-button"></div>
        </div>
      </div>

      {/* 页脚骨架 */}
      <div className="skeleton-footer">
        <div className="skeleton-text skeleton-text-line short"></div>
      </div>
    </div>
  );
}
